var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#E5EDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.706 19.9424C10.7081 20.3157 10.8575 20.673 11.1218 20.9367C11.386 21.2004 11.7437 21.3491 12.117 21.3504H17.763C18.1372 21.3493 18.4957 21.2002 18.7603 20.9357C19.0248 20.6711 19.1739 20.3126 19.175 19.9384V11.4734H10.706V19.9424ZM19.881 9.35639H17.411L16.7 8.65039H13.176L12.47 9.35639H10V10.7674H19.881V9.35639Z",
    fill: "#747478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete2.b81b8cde4636305bc03d7dc01bb59bb5.svg";
export { ForwardRef as ReactComponent };